import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  initials: 'MG',
  bg: '#C2856A',
  textColor: '#FFFFFF',
  quote: 'Llevaba 3 años luchando contra la misma libra de más. En 3 semanas bajé 9 libras y desaparecieron los despertares de las 3 AM. Este protocolo cambió mi forma de entender mi cuerpo.',
  name: 'María G.',
  location: 'Miami FL',
  week: 'Semana 3 del protocolo'
}, {
  initials: 'CR',
  bg: '#2D5A34',
  textColor: '#FFFFFF',
  quote: 'Mi médico me dijo que era normal por la edad. Este libro me explicó lo que ningún doctor tuvo tiempo de explicarme. En la semana 2 tenía energía para llegar a las 5 PM sin cafeína.',
  name: 'Carmen R.',
  location: 'Houston TX',
  week: 'Semana 2 del protocolo'
}, {
  initials: 'LM',
  bg: '#C9A84C',
  textColor: '#1A1A1A',
  quote: 'Pensé que era otro libro más de dietas. No lo es. Es el primero que habla de hormonas de verdad, con ciencia pero en lenguaje normal. Lo recomiendo a toda mujer de 40+ que sienta que su cuerpo ya no la obedece.',
  name: 'Lourdes M.',
  location: 'Los Ángeles CA',
  week: 'Protocolo completo'
}, {
  initials: 'AP',
  bg: '#C2856A',
  textColor: '#FFFFFF',
  quote: 'La hinchazón que tenía después de cada comida desapareció en los primeros 7 días. Bajé 2 tallas en 21 días. Lo que más me sorprendió fue que no pasé hambre ni un solo día.',
  name: 'Ana P.',
  location: 'Chicago IL',
  week: 'Protocolo completo'
}];
export function Testimonials() {
  return <section className="py-20 lg:py-32 bg-white" data-id="element-201">
      <div className="container mx-auto px-6 lg:px-12" data-id="element-202">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-203">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#2D5A34] text-center mb-4" data-id="element-204">
            Lo que dicen las mujeres que ya lo vivieron
          </h2>
          <p className="text-gray-600 text-center mb-12" data-id="element-205">
            Resultados reales. Historias reales.
          </p>

          <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto mb-12" data-id="element-206">
            {testimonials.map((t, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: i * 0.1
          }} className="bg-white rounded-[10px]" style={{
            padding: '20px',
            borderLeft: `4px solid ${t.bg}`,
            boxShadow: '0 2px 12px rgba(0,0,0,0.06)'
          }} data-id="element-207">
                <div className="flex items-center gap-4 mb-4" data-id="element-208">
                  <div className="rounded-full flex items-center justify-center flex-shrink-0" style={{
                width: '52px',
                height: '52px',
                backgroundColor: t.bg,
                color: t.textColor,
                fontSize: '18px',
                fontWeight: 800
              }} data-id="element-209">
                    {t.initials}
                  </div>
                  <div className="text-[#C9A84C] text-lg" data-id="element-210">★★★★★</div>
                </div>
                <p className="mb-4 italic" style={{
              fontSize: '13px',
              color: '#444444',
              lineHeight: 1.6
            }} data-id="element-211">
                  "{t.quote}"
                </p>
                <p style={{
              fontSize: '12px',
              fontWeight: 700,
              color: t.bg
            }} data-id="element-212">
                  — {t.name}, {t.location}
                </p>
                <p style={{
              fontSize: '12px',
              fontWeight: 700,
              color: '#888888'
            }} data-id="element-213">
                  {t.week}
                </p>
              </motion.div>)}
          </div>

          <div className="bg-[#A8D5AC]/20 rounded-2xl p-6 lg:p-8 max-w-3xl mx-auto text-center" data-id="element-214">
            <p className="text-[#2D5A34] font-semibold" data-id="element-215">
              💚 Más de 1,200 mujeres hispanas en USA han completado el
              Protocolo · Satisfacción del 94% · Los resultados pueden variar
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}